var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5408 4.12375L13.0408 2.06375C12.4708 1.85375 11.5408 1.85375 10.9708 2.06375L5.47078 4.12375C4.41078 4.52375 3.55078 5.76375 3.55078 6.89375V14.9937C3.55078 15.8038 4.08078 16.8738 4.73078 17.3538L10.2308 21.4637C11.2008 22.1937 12.7908 22.1937 13.7608 21.4637L19.2608 17.3538C19.9108 16.8638 20.4408 15.8038 20.4408 14.9937V6.89375C20.4508 5.76375 19.5908 4.52375 18.5408 4.12375ZM15.4808 9.72375L11.1808 14.0238C11.0308 14.1737 10.8408 14.2437 10.6508 14.2437C10.4608 14.2437 10.2708 14.1737 10.1208 14.0238L8.52078 12.4037C8.23078 12.1137 8.23078 11.6337 8.52078 11.3438C8.81078 11.0538 9.29078 11.0538 9.58078 11.3438L10.6608 12.4237L14.4308 8.65375C14.7208 8.36375 15.2008 8.36375 15.4908 8.65375C15.7808 8.94375 15.7808 9.43375 15.4808 9.72375Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.635b58a89e13f790712e61bf150823fa.svg";
export { ForwardRef as ReactComponent };